import React, {useState} from 'react'
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import {BASE_URL} from '../helpers/Api';

const TempFileUploader = ({ setFile, idSolicitud }) => {
    const [refresh, setRefresh] = useState(false);
    const token = localStorage.getItem("token");

    const getUploadParams = async ({file, meta}) => {
        const body = new FormData();
        body.append('file', file);
        body.append('solicitud_id', idSolicitud);

        const headers  = { 'Authorization': `Token ${token}` }
        return {url : `${BASE_URL}/api/v1/archivo/`, body,  headers}
    };

    const handleChangeStatus = ({ file, meta }, status) => {
      if (status === 'done') {
        setFile(file.name);
      }

      setRefresh(!refresh);
    };

    return (
      <Dropzone
        getUploadParams={getUploadParams}
        onChangeStatus={handleChangeStatus}
        maxFiles={1}
        multiple={false}
        canCancel={false}
        inputContent={'Da click o arraste el archivo que desea adjuntar'}
        styles={{
          dropzone: {
            borderRadius: '5px',
            backgroundColor: '#fafafa',
            height: '50%',
            width: '80%'
          },
        }}
        accept='*'
      />
    );
}

export default TempFileUploader